import { ExpressCheckoutElement } from '@stripe/react-stripe-js';

import type { WalletAvailability } from '@/context/walletAvailability';

type Props = {
  onReady: (methods: Partial<WalletAvailability>) => void;
};

const hiddenStyle = {
  position: 'absolute' as const,
  left: '-9999px',
  width: '300px',
  height: '60px',
};

export const WalletDetector = ({ onReady }: Props) => (
  <div aria-hidden="true" style={hiddenStyle}>
    <ExpressCheckoutElement
      onConfirm={() => {}}
      onReady={({ availablePaymentMethods }) =>
        onReady({
          googlePay: false, // Disabled on web (SQR-12788)
          applePay: availablePaymentMethods?.applePay ?? false,
        })
      }
    />
  </div>
);
